
const baseUrlDevlopment = "https://localhost:51694/api/"; 
const live_Rt_Url = "https://y8lydq2htf.execute-api.ap-south-1.amazonaws.com/Prod/api/";
const live_Sales_Url = "https://pf4yqilff7.execute-api.ap-south-1.amazonaws.com/Prod/api/";
const GetBaseUrl = () => {
  return live_Sales_Url;
}
export const DomainService = { 
  GetBaseUrl
}